export default __webpack_public_path__ + "static/media/icon-fifth-live.d8542a98.svg";